const styles = theme => ({
  container: {
    opacity: 1,
    borderTopLeftRadius: '16px',
    borderTopRightRadius: '16px',
    borderBottomRightRadius: '2px',
    borderBottomLeftRadius: '16px',
    padding: '4px',
    backgroundColor: 'rgba(238, 249, 255, 1)',
    width: 'fit-content',
    maxWidth: '70%',
    height: '66px',
    minWidth: '200px',
  },
  innerContainer: {
    opacity: 1,
    borderRadius: '12px',
    backgroundColor: 'rgba(255, 255, 255, 1)',
    padding: '8px',
    display: 'flex',
    flexDirection: 'column',
    gap: '0px',
    height: '58px',
  },
  title: {
    fontFamily: 'Lato',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '24px',
    color: 'rgba(7, 24, 34, 1)',
  },
  date: {
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    color: 'rgba(16, 60, 86, 1)',
  },
})

export default styles
